// @ts-nocheck
import { applyMiddleware, compose, combineReducers, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import pendingReducer from '../../common/state/pending/pendingReducer';
import authReducer from '../../features/auth/state/authReducer';
import customerReducer from '../../features/customers/state/customerReducer';
import subscriptionReducer from '../../features/subscriptions/state/subscriptionReducer';
import orderReducer from '../../features/orders/state/orderReducer';
import activityReducer from '../../features/activities/state/activityReducer';
import eventReducer from '../../features/events/state/eventReducer';
import voucherReducer from '../../features/vouchers/state/voucherReducer';
import campaignReducer from '../../features/campaigns/state/campaignReducer';
import messageReducer from '../../features/messages/state/messageReducer';
import companyReducer from '../../features/companies/state/companyReducer';
import productReducer from '../../features/products/state/productReducer';

function configureStore(preloadedState) {
  const middlewares = [thunkMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers = [middlewareEnhancer];
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const composedEnhancers = composeEnhancers(...enhancers);

  const rootReducer = combineReducers({
    pending: pendingReducer,
    auth: authReducer,
    customer: customerReducer,
    subscription: subscriptionReducer,
    order: orderReducer,
    activity: activityReducer,
    event: eventReducer,
    voucher: voucherReducer,
    campaign: campaignReducer,
    message: messageReducer,
    company: companyReducer,
    product: productReducer,
  });

  const store = createStore(rootReducer, preloadedState, composedEnhancers);
  return store;
}

export default configureStore;
